import React, {useState} from 'react';

import b_ from 'b_';

import {Button} from 'client/common/components/lego';

import I18N from 'assets/i18n/brandlift-project';

import ClientSelect from './client-select';

import {ClientSelectModalProps} from './types';

import './client-select-modal.css';

const i18n = I18N.common.clientSelect;
const b = b_.with('client-select-modal');

export function ClientSelectModal(props: ClientSelectModalProps) {
    const {onFinish} = props;

    const [clientId, setClientId] = useState<string>();

    const handleContinueClick = () => {
        if (!clientId) {
            return;
        }

        onFinish(clientId);
    };

    return (
        <div className={b()}>
            <h1 className={b('title')}>{i18n.modal.title}</h1>
            <ClientSelect
                className={b('client-select')}
                onChange={setClientId}
                selectedId={clientId}
            />
            <Button
                className={b('continue-button')}
                disabled={!clientId}
                onClick={handleContinueClick}
                view='default'
                size='m'
            >
                {i18n.modal.continue}
            </Button>
        </div>
    );
}
